(function () {
  'use strict';

  if (window.KMCourseGiftCardEmbed) {
    window.KMCourseGiftCardEmbed.initAll();
    return;
  }

  var source = 'kurs-gutschein-box';

  function readConfig() {
    var configElement = document.querySelector('[data-km-course-gift-card-config]');

    if (!configElement) return {};

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('[km-gutschein-box] Ungültige Konfiguration.', error);
      return {};
    }
  }

  function storefrontRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);

    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;

    return element;
  }

  function clearElement(element) {
    while (element.firstChild) element.removeChild(element.firstChild);
  }

  function formatPrice(price, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency
      }).format(price);
    } catch (error) {
      return price.toFixed(2) + ' ' + currency;
    }
  }

  function publishSourceEvent(product, variant, price, currency, handle) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

    try {
      var result = window.Shopify.analytics.publish('kaffeemacher:course_gift_card_added', {
        source: source,
        productId: String(product.id),
        variantId: String(variant.id),
        productHandle: handle,
        productTitle: product.title,
        price: price,
        currency: currency,
        quantity: 1
      });

      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {
      console.error('[km-gutschein-box] Analytics-Event konnte nicht veröffentlicht werden.', error);
    }
  }

  /* Disabled to avoid duplicating Shopify's native add_to_cart event.
  function sendLegacyAddToCartEvent(product, price, handle, callback) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    window.gtag('event', 'add_to_cart', {
      send_to: 'G-K061ENDHLG',
      currency: 'EUR',
      value: price,
      items: [{
        item_id: handle,
        item_name: product.title,
        item_category: 'gutschein_produktbox',
        price: price,
        quantity: 1
      }],
      event_callback: callback
    });

    window.setTimeout(callback, 1000);
  }
  */

  function addToCart(button, product, variant, handle, config) {
    var price = Number(variant.price);
    var currency = variant.price_currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

    button.textContent = config.addingToCart;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch(storefrontRoute('cart/add.js'), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variant.id,
        quantity: 1,
        properties: { '_quelle': source }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed with status ' + response.status);
        return response.json();
      })
      .then(function () {
        button.textContent = config.addedToCart;
        button.classList.add('success');
        button.removeAttribute('aria-busy');

        var navigated = false;
        function goToCart() {
          if (navigated) return;
          navigated = true;
          window.location.assign(storefrontRoute('cart'));
        }

        publishSourceEvent(product, variant, price, currency, handle);
        // Disabled to avoid duplicating Shopify's native add_to_cart event.
        // sendLegacyAddToCartEvent(product, price, handle, goToCart);
        goToCart();
      })
      .catch(function (error) {
        console.error('[km-gutschein-box]', error);
        window.alert(config.cartError);
        button.textContent = config.addToCart;
        button.classList.remove('success');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  function showLoadError(wrapper, config, error) {
    console.error('[km-gutschein-box]', error);
    clearElement(wrapper);
    wrapper.classList.add('km-gift-embed--error');

    var message = createElement('p', null, config.loadError);
    message.setAttribute('role', 'status');
    wrapper.appendChild(message);
  }

  function renderBox(wrapper, product, variant, handle, config) {
    var price = Number(variant.price);
    var currency = variant.price_currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var iconTemplate = document.querySelector('[data-km-course-gift-card-icon]');

    clearElement(wrapper);
    wrapper.classList.add('km-gift-box');

    if (iconTemplate) wrapper.appendChild(iconTemplate.content.cloneNode(true));

    var info = createElement('div', 'km-gift-info');
    info.appendChild(createElement('div', 'km-gift-subtitle', config.subtitle));
    info.appendChild(createElement('div', 'km-gift-title', product.title));
    info.appendChild(createElement('div', 'km-gift-sub', config.description));
    wrapper.appendChild(info);

    var actions = createElement('div', 'km-gift-actions');
    actions.appendChild(createElement('div', 'km-gift-price', formatPrice(price, currency)));

    var button = createElement('button', 'km-gift-btn', config.addToCart);
    button.type = 'button';
    button.addEventListener('click', function () {
      addToCart(button, product, variant, handle, config);
    });
    actions.appendChild(button);

    var details = createElement('a', 'km-gift-link', config.viewDetails);
    details.href = storefrontRoute('products/' + encodeURIComponent(handle));
    actions.appendChild(details);
    wrapper.appendChild(actions);
  }

  function initBox(wrapper) {
    if (wrapper.dataset.initialized) return;

    var handle = wrapper.getAttribute('data-handle');
    var config = readConfig();

    wrapper.dataset.initialized = 'true';

    if (!handle) {
      showLoadError(wrapper, config, new Error('data-handle fehlt.'));
      return;
    }

    fetch(storefrontRoute('products/' + encodeURIComponent(handle) + '.json'), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed with status ' + response.status);
        return response.json();
      })
      .then(function (json) {
        var product = json.product;
        var variant = product && product.variants && product.variants[0];

        if (!product || !variant) throw new Error('Produkt oder Variante fehlt.');
        renderBox(wrapper, product, variant, handle, config);
      })
      .catch(function (error) {
        showLoadError(wrapper, config, error);
      });
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('.km-gift-embed')) initBox(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.km-gift-embed').forEach(initBox);
  }

  window.KMCourseGiftCardEmbed = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
